import type { FC, SVGAttributes } from 'react';
import React from 'react';

export const ArrowIcon: FC<SVGAttributes<SVGElement>> = props => (
    <svg fill="none" height="14" width="20" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M19.728 6.342L13.776.391a.93.93 0 00-1.315 1.315l4.364 4.364H.93a.93.93 0 000 1.86h15.895l-4.364 4.364a.93.93 0 101.315 1.315l5.952-5.951a.93.93 0 000-1.316z"
            fill="#6D7986"
        />
    </svg>
);
